export default __webpack_public_path__ + "static/char-s-36-ko-b4bcc240864314512315a8a5d2713f6d.webp";